module.exports = __webpack_public_path__ + "img/logo.033407ab.png";